import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MotifModule } from '@app/motif.module';
import { PrivacyNoticeComponent } from './privacy-notice.component';



@NgModule({
  declarations: [
    PrivacyNoticeComponent
  ],
  imports: [
    CommonModule,
    MotifModule
  ]
})
export class PrivacyNoticeModule { }
